import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { merge } from 'rxjs';

@Injectable()
export class PickAdvertiserResolve implements Resolve<any> {
  constructor(private authService: AuthService) {}

  resolve(route: ActivatedRouteSnapshot) {
    let sessionResolve = this.authService.checkSession();
    return merge(sessionResolve);
  }
}
